<template>
  <div class="container" style="max-width: 72rem">

    <section class="my-6">
      <ProfileURL is_editable />
    </section>

    <section class="my-6">
      <Education is_editable />
    </section>

    <section class="my-6">
      <Achievement is_editable />
    </section>

    <section class="my-6">
      <Research is_editable />
    </section>

    <section class="my-6 mentorship-areas">
      <MentorshipAreas is_editable />
    </section>
  </div>
</template>

<script>
import MentorshipAreas from '../../components/common/Experience';
import Education from '../../components/common/Education';
import Research from '../../components/common/Research';
import Achievement from '../../components/common/Achievement';
import ProfileURL from '../../components/common/ProfileURL';

export default {
  components: {
    MentorshipAreas,
    Education,
    Research,
    Achievement,
    ProfileURL,
  },
};
</script>

<style scoped>
@media (min-width: 769px) {
  .vertical-divider {
    border-left: lightgray dashed 1px;
  }
}
</style>
